import { Inject, Injectable } from '@angular/core';
import { LayoutStore } from './layout.store';
import { LayoutQueries } from '@/app/core/store/types';
import { combineLatest, Observable } from 'rxjs';
import { Listener, LISTENERS } from '@/types/listener.types';
import { delay, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LayoutStoreQueries implements LayoutQueries {
  constructor(
    private readonly store: LayoutStore,
    @Inject(LISTENERS)
    private readonly listeners: Listener[]
  ) {}

  isSideBarOpen$: Observable<boolean> = this.store.select(s => s.isSideBarOpen);
  showLoginDialog$: Observable<boolean> = this.store.select(s => s.showLoginDialog);

  getShowLoginDialog(): boolean {
    return this.store.getValue().showLoginDialog;
  }

  showAvailabilityError$: Observable<boolean> = combineLatest([
    ...this.listeners.map(l => l.isAvailable$)
  ]).pipe(map(availabilities => availabilities.some(a => !a)));

  showAppMenu$: Observable<boolean> = this.store.select(s => s.showAppMenu);

  getShowAppMenu(): boolean {
    return this.store.getValue().showAppMenu;
  }

  isLoading$: Observable<boolean> = this.store.select(s => s.isLoading).pipe(delay(0));

  isFullscreen$ = this.store.select(s => s.isFullscreen);
}
